// extracted by mini-css-extract-plugin
var _1 = "styles-module__count___xuAxm";
export { _1 as "count" }
